import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const items = ['Quieres resultados sostenibles sin dietas extremas.', 'Buscas un método práctico que encaje en tu rutina.', 'Estás listo para construir disciplina diaria con pequeños pasos.'];
export function ForYouSection() {
  return <section className="py-24 bg-[#0A0A0A] border-t border-gray-900" data-id="element-73">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="max-w-4xl mx-auto bg-gradient-to-r from-gray-900 to-[#0A0A0A] rounded-3xl p-8 md:p-16 border border-gray-800 shadow-2xl" data-id="element-75">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-76">
            <div data-id="element-77">
              <motion.h2 initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-78">
                Este ebook es <br data-id="element-79" />
                <span className="text-[#22C55E]" data-id="element-80">para ti si...</span>
              </motion.h2>

              <div className="space-y-6" data-id="element-81">
                {items.map((item, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.2
              }} className="flex items-start gap-4" data-id="element-82">
                    <div className="mt-1 bg-[#22C55E]/20 p-1 rounded-full" data-id="element-83">
                      <CheckCircle2 className="w-5 h-5 text-[#22C55E]" data-id="element-84" />
                    </div>
                    <p className="text-lg text-gray-300" data-id="element-85">{item}</p>
                  </motion.div>)}
              </div>
            </div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="relative hidden md:block" data-id="element-86">
              <div className="absolute inset-0 bg-[#22C55E] blur-[80px] opacity-20 rounded-full" data-id="element-87" />
              <img src="https://cdn.magicpatterns.com/uploads/mCAyv9HnDDjj7L5kt47dz5/ChatGPT_Image_13_mar_2026,_15_47_00.png" alt="Ebook Preview" className="relative z-10 w-full rounded-lg shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-88" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}